const urlTitle = window.siteConfig.v2homepage ? `${window.siteConfig.v2homepage.url}` : `rendez-vous-garage-${window.siteConfig.brand}`
const v2HomepageUrl = `${window.siteConfig.language}-${window.siteConfig.currentCountry}/${window.siteConfig.v2homepage.url}`
const defaultHomePageUrl = `${window.siteConfig.language}-${window.siteConfig.currentCountry}/rendez-vous-garage-${window.siteConfig.brand}`
const CONSTANTS = {
  LABELS: {
    ...window.labels
  },

  SITE_ROUTS: {/*
    // HOMEPAGEnew:  window.siteConfig.rootPath + '/' + (window.siteConfig.v2homepage ? window.siteConfig.language + '-' +
    // window.siteConfig.currentCountry+'/'+window.siteConfig.v2homepage.url : window.siteConfig.language + '-' +
    // window.siteConfig.currentCountry+'/'+'rendez-vous-garage-' + window.siteConfig.brand),
    // LISTDEALERSPAGE: window.siteConfig.rootPath + '/' + (window.siteConfig.v2homepage ? window.siteConfig.v2homepage.url : 'rendez-vous-garage-' + window.siteConfig.brand),
    // SOLODEALERPAGE: window.siteConfig.rootPath + '/' + (window.siteConfig.v2homepage ? window.siteConfig.language +
     '-' + window.siteConfig.currentCountry+'/'+window.siteConfig.v2homepage.url : window.siteConfig.language +
     '-' + window.siteConfig.currentCountry+'/'+'rendez-vous-garage-' + window.siteConfig.brand) + '/',
    // CARDETECTIONPAGE: window.siteConfig.rootPath + '/' + (window.siteConfig.v2homepage ?window.siteConfig.language +
     '-' + window.siteConfig.currentCountry+'/'+ window.siteConfig.v2homepage.url : window.siteConfig.language + '-' +
      window.siteConfig.currentCountry+'/'+'rendez-vous-garage-' + window.siteConfig.brand) + '/' +
       (window.siteConfig.v2vehicule ? window.siteConfig.v2vehicule.url : 'vehicule'),
    // SERVICESPAGE: window.siteConfig.rootPath + '/' + (window.siteConfig.v2homepage ? window.siteConfig.language +
     '-' + window.siteConfig.currentCountry+'/'+window.siteConfig.v2homepage.url :window.siteConfig.language +
      '-' + window.siteConfig.currentCountry+'/'+ 'rendez-vous-garage-' + window.siteConfig.brand) + '/' +
       (window.siteConfig.v2prestations ? window.siteConfig.v2prestations.url : 'prestations'),
    // PERSONNALDETAILSPAGE: window.siteConfig.rootPath + '/' + (window.siteConfig.v2homepage ? window.siteConfig.language +
     '-' + window.siteConfig.currentCountry+'/'+window.siteConfig.v2homepage.url :window.siteConfig.language +
      '-' + window.siteConfig.currentCountry+'/'+ 'rendez-vous-garage-' + window.siteConfig.brand) +
       '/' + (window.siteConfig.v2infospersos ? window.siteConfig.v2infospersos.url : 'information-personnelles'),
    // SUMMARYPAGE: window.siteConfig.rootPath + '/' + (window.siteConfig.v2homepage ?window.siteConfig.language +
     '-' + window.siteConfig.currentCountry+'/'+ window.siteConfig.v2homepage.url :window.siteConfig.language +
      '-' + window.siteConfig.currentCountry+'/'+ 'rendez-vous-garage-' + window.siteConfig.brand) +
       '/' + (window.siteConfig.v2recapitulatif ? window.siteConfig.v2recapitulatif.url : 'recapitulatif'),
    // CONFIRMATION: window.siteConfig.rootPath + '/'+ (window.siteConfig.v2homepage ? window.siteConfig.language +
     '-' + window.siteConfig.currentCountry+'/'+window.siteConfig.v2homepage.url :window.siteConfig.language +
      '-' + window.siteConfig.currentCountry+'/'+'rendez-vous-garage-' + window.siteConfig.brand) +
       '/' + (window.siteConfig.v2confirmation ? window.siteConfig.v2confirmation.url : 'confirmation'),
    // EDITRDV: window.siteConfig.rootPath + '/' + (window.siteConfig.v2homepage ? window.siteConfig.language +
     '-' + window.siteConfig.currentCountry+'/'+window.siteConfig.v2homepage.url :window.siteConfig.language +
     '-' + window.siteConfig.currentCountry+'/'+ 'rendez-vous-garage-' + window.siteConfig.brand) +
      '/' + (window.siteConfig.v2modification ? window.siteConfig.v2modification.url : 'modification'),


    //HOMEPAGEOLD:window.siteConfig.rootPath +
     '/' +(window.siteConfig.v2homepage ?window.siteConfig.v2homepage.url :'rendez-vous-garage-' + window.siteConfig.brand),
    // LISTDEALERSPAGEOld: window.siteConfig.rootPath +
     '/' + (window.siteConfig.v2homepage ? window.siteConfig.v2homepage.url : 'rendez-vous-garage-' + window.siteConfig.brand),
    //SOLODEALERPAGEO ld: window.siteConfig.rootPath +
    '/' + (window.siteConfig.v2homepage ? window.siteConfig.v2homepage.url : 'rendez-vous-garage-' + window.siteConfig.brand) + '/',
    // CARDETECTIONPAGEOld: window.siteConfig.rootPath +
     '/' + (window.siteConfig.v2homepage ?window.siteConfig.v2homepage.url :'rendez-vous-garage-' + window.siteConfig.brand) +
      '/' + (window.siteConfig.v2vehicule ? window.siteConfig.v2vehicule.url : 'vehicule'),
    // SERVICESPAGEOld: window.siteConfig.rootPath +
     '/' + (window.siteConfig.v2homepage ?window.siteConfig.v2homepage.url :'rendez-vous-garage-' + window.siteConfig.brand) +
      '/' + (window.siteConfig.v2prestations ? window.siteConfig.v2prestations.url : 'prestations'),
    // PERSONNALDETAILSPAGEOld: window.siteConfig.rootPath +
     '/' + (window.siteConfig.v2homepage ? window.siteConfig.v2homepage.url : 'rendez-vous-garage-' + window.siteConfig.brand) +
      '/' + (window.siteConfig.v2infospersos ? window.siteConfig.v2infospersos.url : 'information-personnelles'),
    // SUMMARYPAGEOld: window.siteConfig.rootPath +
     '/' + (window.siteConfig.v2homepage ? window.siteConfig.v2homepage.url : 'rendez-vous-garage-' + window.siteConfig.brand) +
      '/' + (window.siteConfig.v2recapitulatif ? window.siteConfig.v2recapitulatif.url : 'recapitulatif'),
    // CONFIRMATIONOld: window.siteConfig.rootPath + '/'+ (window.siteConfig.v2homepage ? window.siteConfig.v2homepage.url :'rendez-vous-garage-' +
     window.siteConfig.brand) + '/' + (window.siteConfig.v2confirmation ? window.siteConfig.v2confirmation.url : 'confirmation'),
    // EDITRDVOLD: window.siteConfig.rootPath +
     '/' + (window.siteConfig.v2homepage ? window.siteConfig.v2homepage.url : 'rendez-vous-garage-' +
      window.siteConfig.brand) + '/' + (window.siteConfig.v2modification ? window.siteConfig.v2modification.url : 'modification')
    */
    V2HOMEPAGE: ` /${urlTitle}`,
    HOMEPAGE: (window.siteConfig.nbrCulture > 1
      ?
      `${window.siteConfig.rootPath}/${(window.siteConfig.v2homepage ? v2HomepageUrl : defaultHomePageUrl)}`
      :
      `${window.siteConfig.rootPath}/${urlTitle}`
    ),
    V2LISTDEALERSPAGE: `/${urlTitle}`,
    LISTDEALERSPAGE: (window.siteConfig.nbrCulture > 1
      ?
      `${window.siteConfig.rootPath}/${(window.siteConfig.v2homepage ? v2HomepageUrl : defaultHomePageUrl)}`
      :
      `${window.siteConfig.rootPath}/${urlTitle}`

    ),
    V2SOLODEALERPAGE: `/${urlTitle}/`,
    SOLODEALERPAGE: (window.siteConfig.nbrCulture > 1
      ?
      `${window.siteConfig.rootPath}/${(window.siteConfig.v2homepage ? v2HomepageUrl : defaultHomePageUrl)}/`
      :
      `${window.siteConfig.rootPath}/${urlTitle}/`
    ),
    CARDETECTIONPAGE: (window.siteConfig.nbrCulture > 1
      ?
      `${window.siteConfig.rootPath}/${(window.siteConfig.v2homepage ? v2HomepageUrl : defaultHomePageUrl)}` +
      `/${(window.siteConfig.v2vehicule ? window.siteConfig.v2vehicule.url : 'vehicule')}`
      :
      `${window.siteConfig.rootPath}/${urlTitle}/${(window.siteConfig.v2vehicule ? window.siteConfig.v2vehicule.url : 'vehicule')}`),


    SERVICESPAGE: (window.siteConfig.nbrCulture > 1
      ?
      `${window.siteConfig.rootPath}/${(window.siteConfig.v2homepage ? v2HomepageUrl : defaultHomePageUrl)}` +
      `/${(window.siteConfig.v2prestations ? window.siteConfig.v2prestations.url : 'prestations')}`
      :
      `${window.siteConfig.rootPath}/${urlTitle}/${(window.siteConfig.v2prestations ? window.siteConfig.v2prestations.url : 'prestations')}`),


    PERSONNALDETAILSPAGE: (window.siteConfig.nbrCulture > 1
      ?
      `${window.siteConfig.rootPath}/${(window.siteConfig.v2homepage ? v2HomepageUrl : defaultHomePageUrl)}` +
      `/${(window.siteConfig.v2infospersos ? window.siteConfig.v2infospersos.url : 'information-personnelles')}`
      :
      `${window.siteConfig.rootPath}/${urlTitle}/${(window.siteConfig.v2infospersos ? window.siteConfig.v2infospersos.url : 'information-personnelles')}`),


    SUMMARYPAGE: (window.siteConfig.nbrCulture > 1
      ?
      `${window.siteConfig.rootPath}/${(window.siteConfig.v2homepage ? v2HomepageUrl : defaultHomePageUrl)}` +
      `/${(window.siteConfig.v2recapitulatif ? window.siteConfig.v2recapitulatif.url : 'recapitulatif')}`
      :
      `${window.siteConfig.rootPath}/${urlTitle}` +
      `/${(window.siteConfig.v2recapitulatif ? window.siteConfig.v2recapitulatif.url : 'recapitulatif')}`),


    CONFIRMATION: (window.siteConfig.nbrCulture > 1
      ?
      `${window.siteConfig.rootPath}/${(window.siteConfig.v2homepage ? v2HomepageUrl : defaultHomePageUrl)}` +
      `/${(window.siteConfig.v2confirmation ? window.siteConfig.v2confirmation.url : 'confirmation')}`
      :
      `${window.siteConfig.rootPath}/${urlTitle}` +
      `/${(window.siteConfig.v2confirmation ? window.siteConfig.v2confirmation.url : 'confirmation')}`),

    V2EDITRDV: `/${urlTitle}/${(window.siteConfig.v2modification ? window.siteConfig.v2modification.url : 'modification')}`,

    EDITRDV: (window.siteConfig.nbrCulture > 1
      ?
      `${window.siteConfig.rootPath}/${(window.siteConfig.v2homepage ? v2HomepageUrl : defaultHomePageUrl)}` +
      `/${(window.siteConfig.v2modification ? window.siteConfig.v2modification.url : 'modification')}`
      :
      `${window.siteConfig.rootPath}/${urlTitle}` +
      `/${(window.siteConfig.v2modification ? window.siteConfig.v2modification.url : 'modification')}`)

  },
  SITE_INFO: {
    DealerName: window.siteConfig.DealerName,
    CountryName: window.siteConfig.CountryName,
    CULTURE: `${window.siteConfig.language}-${window.siteConfig.currentCountry}`,
    BRAND_CODE: window.siteConfig.currentBrand,
    BRAND_NAME: window.siteConfig.brand,
    PHONEREGEX: window.siteConfig.phoneRegex,
    MENTIONLEGAL: window.siteConfig.MentionLegal,
    GDPR: window.siteConfig.gdpr,
    PHONEMASK: window.labels.userinfos_tel_example,
    VINIMAGE: window.siteConfig.vinImage,
    EMAILMASK: window.labels.userinfos_email_example,
    ACTIVATENEWAPPOINTMENTJOURNEY: window.siteConfig.ActivateNewAppointmentJourney,
    ACTIVATEATTACHMENTTOOL: window.siteConfig.ActivateAttachmentTool,
    GOOGLE_MAP_API_KEY: window.siteConfig.GoogleMapApiKey
  },
  SITE_CONFIG: {
    ...window.siteConfig
  }
}

export default CONSTANTS
